import axios from "../axios-auth";
import orginal_axios from "axios";

export const saleIssueService = {
  getSaleIssueList,
  getSaleIssueDetailList,
  exportAllSaleIssueExcel,
  printInvoiceById,
  showWindowDialog
};

function getSaleIssueList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return axios.get("/auth/sale-issue", { params });
}

function getSaleIssueDetailList(wholeSaleHeaderId) {
  return axios.get("/auth/sale-issue-details/" + wholeSaleHeaderId);
}

function exportAllSaleIssueExcel(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.description) {
    params["description"] = searchParams.description;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/sale-issue-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function printInvoiceById(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-sale-issue-invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}
